/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CloneDeviceDto,
  DeviceBreadcrumbsDto,
  DevicesV2ControllerCloneDeviceV2PathParameters,
  DevicesV2ControllerFindAllV2200AllOf,
  DevicesV2ControllerFindAllV2Params,
  DevicesV2ControllerFindAllV2PathParameters,
  DevicesV2ControllerGetAvailableFiltersV2Params,
  DevicesV2ControllerGetAvailableFiltersV2PathParameters,
  DevicesV2ControllerGetDeviceBreadcrumbsV2PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DevicesV2Service {
  private readonly http = inject(HttpClient);
  /**
   * Retrieves a list of devices for a client
   * @summary Get list of devices
   */

  findAll<TData = DevicesV2ControllerFindAllV2200AllOf>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DevicesV2ControllerFindAllV2PathParameters,
    params?: DevicesV2ControllerFindAllV2Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v2/clients/${clientId}/devices`, {
      params: (() => {
        const objectParamStrategies: Readonly<Record<string, 'flatten' | 'comma' | 'deepObject'>> = { filters: 'flatten' };

        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (
            value != null &&
            typeof value === 'object' &&
            !Array.isArray(value) &&
            Object.prototype.hasOwnProperty.call(objectParamStrategies, key)
          ) {
            const objectStrategy = objectParamStrategies[key];
            const entries = Object.entries(value as Record<string, unknown>);
            if (objectStrategy === 'comma') {
              const commaParts: string[] = [];
              for (const [prop, propValue] of entries) {
                if (Array.isArray(propValue)) {
                  const filteredItems = propValue.filter(
                    item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
                  ) as Array<string | number | boolean>;
                  if (filteredItems.length) {
                    commaParts.push(prop, ...filteredItems.map(String));
                  }
                } else if (
                  propValue != null &&
                  (typeof propValue === 'string' || typeof propValue === 'number' || typeof propValue === 'boolean')
                ) {
                  commaParts.push(prop, String(propValue));
                }
              }
              if (commaParts.length) {
                filteredParams[key] = commaParts.join(',');
              }
            } else {
              for (const [prop, propValue] of entries) {
                const targetKey = objectStrategy === 'deepObject' ? key + '[' + prop + ']' : prop;
                if (Array.isArray(propValue)) {
                  const filteredProp = propValue.filter(
                    item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
                  ) as Array<string | number | boolean>;
                  if (filteredProp.length) {
                    filteredParams[targetKey] = filteredProp;
                  }
                } else if (
                  propValue != null &&
                  (typeof propValue === 'string' || typeof propValue === 'number' || typeof propValue === 'boolean')
                ) {
                  filteredParams[targetKey] = propValue;
                }
              }
            }
            continue;
          }
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * Retrieves available filters for devices
   * @summary Get available filters
   */

  getAvailableFilters<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DevicesV2ControllerGetAvailableFiltersV2PathParameters,
    params?: DevicesV2ControllerGetAvailableFiltersV2Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v2/clients/${clientId}/devices/filters`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * @summary Get breadcrumbs path for a device or child device
   */

  getDeviceBreadcrumbs<TData = DeviceBreadcrumbsDto>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
  }: DevicesV2ControllerGetDeviceBreadcrumbsV2PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v2/clients/${clientId}/devices/${deviceId}/breadcrumbs`);
  }
  /**
   * Copies a device
   * @summary Clone device
   */

  cloneDevice<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: DevicesV2ControllerCloneDeviceV2PathParameters,
    cloneDeviceDto: CloneDeviceDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v2/clients/${clientId}/devices/${deviceId}/clone`, cloneDeviceDto);
  }
}
